import axios from '@/utils/request'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块
let url = "http://website.pc.dahehuodongbao.com:8089"
// let url = "http://websitetest.pc.dahehuodongbao.com:8089"
const api = {
    // 热点新闻列表
    newsList (params) {
        return axios.get(`${url}/open/api/news`,{            
            params: params        
        });
    },
    // 热点动态详情
    newsDetail (params) {
        return axios.get(`${url}/open/api/news/${params}`);
    },
    // banner列表
    getBanner (params) {
        return axios.get(`${url}/open/api/banner`,{            
            params: params        
        });
    },
    // 活动列表
    getActivityDetail (params) {
        return axios.get(`${url}/open/api/activity/${params}`);
    },
    // 活动详情
    getActivity (params) {
        return axios.get(`${url}/open/api/activity`,{            
            params: params        
        });
    },
    // 专家智库列表
    getTeacher (params) {
        return axios.get(`${url}/open/api/teacher`,{            
            params: params        
        });
    },
    // 专家智库列表
    getCourse (params) {
        return axios.get(`${url}/open/api/courseContent`,{            
            params: params        
        });
    },
    // 热点动态详情
    getCourseDetail (params) {
        return axios.get(`${url}/open/api/courseContent/${params}`);
    },
    // 三大板块列表
    getBusinessPlate (params) {
        return axios.get(`${url}/open/api/businessPlate`,{            
            params: params        
        });
    },
    // 课程现场列表
    getCourseScene (params) {
        return axios.get(`${url}/open/api/courseScene`,{            
            params: params        
        });
    },
    // 业务模块列表
    getMainBusiness (params) {
        return axios.get(`${url}/open/api/mainBusiness`,{            
            params: params        
        });
    },    
    // 板块简介
    getBusinessPlateDetails (params) {
        return axios.get(`${url}/open/api/businessPlateDetails`,{            
            params: params        
        });
    }, 
    // 板块简介
    getBriefIntroduction (params) {
        return axios.get(`${url}/open/api/briefIntroduction`,{            
            params: params        
        });
    },    
    // 精彩模块
    getVideo (params) {
        return axios.get(`${url}/open/api/video`,{            
            params: params        
        });
    },  
    // 发展历程
    getTimeAxis (params) {
        return axios.get(`${url}/open/api/timeAxis`,{            
            params: params        
        });
    },
    // 荣誉资质
    getHonorwall (params) {
        return axios.get(`${url}/open/api/honorwall`,{            
            params: params        
        });
    },
    // 反馈留言
    feedbackMessage (data) {
        return axios.post(`${url}/open/api/feedbackMessage`,data);
    },
    // 立即报名
    subscribe (data) {
        return axios.post(`${url}/open/api/subscribe`,data);
    },
    // 首页-热点动态-有分页
    newsListAll (params) {
        return axios.get(`${url}/open/api/news/all`,{            
            params: params        
        });
    },
}

export default api;


// WEBPACK FOOTER //
// ./src/api/index.js